import { Brain, Target, Filter, BarChart3 } from "lucide-react";

const featureRows = [
  {
    icon: Brain,
    title: "Flashcards tipo Anki",
    description:
      "Tarjetas clásicas y cloze con repetición espaciada para repasar lo que todavía no dominas.",
  },
  {
    icon: Target,
    title: "Simuladores configurables",
    description:
      "Elige áreas, dificultad, tiempo, número de preguntas y la fuente clínica que quieres practicar.",
  },
  {
    icon: Filter,
    title: "Una biblioteca, fuentes claras",
    description:
      "Cada tema consolida sus materiales sin perder el origen: PRONAM, GPC, NOM y consensos.",
  },
  {
    icon: BarChart3,
    title: "Progreso útil",
    description:
      "Identifica temas pendientes, revisa tu desempeño y decide dónde invertir tu siguiente sesión.",
  },
];

export function FeaturesSection() {
  return (
    <section id="producto" className="py-20 lg:py-28">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl">
          <p className="text-sm font-bold uppercase text-primary">Producto</p>
          <h2 className="mt-3 text-3xl font-bold sm:text-4xl lg:text-5xl">Repasa con criterio, no con ruido</h2>
          <p className="mt-5 text-lg text-muted-foreground">La plataforma reúne práctica activa y fuentes clínicas identificables para que puedas complementar el método que ya utilizas.</p>
        </div>
        <div className="mt-12 grid border-l border-t border-border md:grid-cols-2">
          {featureRows.map((feature) => (
            <article key={feature.title} className="border-b border-r border-border p-7 sm:p-9">
              <feature.icon className="h-7 w-7 text-primary" />
              <h3 className="mt-6 text-xl font-bold">{feature.title}</h3>
              <p className="mt-3 leading-relaxed text-muted-foreground">{feature.description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
